var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SliderComp',{attrs:{"items":_vm.products,"key-prefix":"homePageProducts","per-page":"6","loop":false,"rewind":"","breakpoints":_vm.productBreakPoints},scopedSlots:_vm._u([{key:"slide-item",fn:function(ref){
var item = ref.item;
return [_c('ProductCard',{attrs:{"item":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }